import { Component, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { FieldsetModule } from 'primeng/fieldset';
import { Router } from '@angular/router';
import { FloatLabelModule } from 'primeng/floatlabel';
import { LAUNCH_CONTAINER_OPTIONS, TARGET_LINK_URI_CUSTOMIZATION_VALUES } from '../../constants/tools.constants';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { StepperModule } from 'primeng/stepper';
import { TabsModule } from 'primeng/tabs';
import { MessageModule } from 'primeng/message';
import { ToolsService } from '../../services/tools.service';
import { ToastService } from '../../../../common/services/toast.service';
@Component({
  selector: 'app-add-tool',
  imports: [
    ButtonModule,
    InputTextModule,
    ReactiveFormsModule,
    TextareaModule,
    SelectModule,
    CheckboxModule,
    FieldsetModule,
    FloatLabelModule,
    ToggleSwitchModule,
    StepperModule,
    TabsModule,
    MessageModule,
    NgClass
  ],
  templateUrl: './add-tool.html',
  styleUrls: ['./add-tool.css'],
  providers:[ToolsService, ToastService]
})
export class AddToolComponent implements OnInit {
 addToolFormGroup:FormGroup
 launchContainerOptions;
 targetLinkURICustomizationOptions;
 URL_PATTERN = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private toolsService:ToolsService,
    private router: Router
  ) {
    
    this.launchContainerOptions  = LAUNCH_CONTAINER_OPTIONS;
    this.targetLinkURICustomizationOptions = TARGET_LINK_URI_CUSTOMIZATION_VALUES;
    this.addToolFormGroup = this.fb.group({
        name: ['',[Validators.required, Validators.minLength(5),Validators.maxLength(150)]],
        description: [''],
        toolURL: ['',[Validators.required,Validators.pattern(this.URL_PATTERN)]],
        ltiVersion: ['1.3'],
        publicKeysetURL: ['',[Validators.required,Validators.pattern(this.URL_PATTERN)]],
        initiateLoginURL: ['',[Validators.required,Validators.pattern(this.URL_PATTERN)]],
        redirectURIs: ['',[Validators.required,this.redirectUrisValidator()]],
        customParameters: ['N.A.'],
        launchContainer: [LAUNCH_CONTAINER_OPTIONS[0],Validators.required],
        supportsDeepLinking: [true,Validators.required],
        deeplinkingURL: ['',[Validators.required, Validators.pattern(this.URL_PATTERN)]],
        isAssignmentAndGradeServiceEnabled: [true,Validators.required],
        isNamesAndRoleProvisioningServiceEnabled: [true,Validators.required],
        isSharingFullNameOfLearnerWithToolEnabled: [true,Validators.required],
        isSharingEmailOfLearnerWithToolEnabled: [true,Validators.required],
        targetLinkURICustomization:[TARGET_LINK_URI_CUSTOMIZATION_VALUES[1],Validators.required]
    });
  }

  // Validates a comma/space separated list of redirect URIs; each entry must match URL_PATTERN.
  private redirectUrisValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = (control.value ?? '').toString().trim();
      if (!value) {
        return null;
      }
      const uris = value.split(/[\s,]+/).filter((uri: string) => uri.length > 0);
      if (uris.length === 0 || uris.some((uri: string) => !this.URL_PATTERN.test(uri))) {
        return { pattern: true };
      }
      return null;
    };
  }

  ngOnInit(): void {
    this.addToolFormGroup.get('supportsDeepLinking')?.valueChanges.subscribe((checked: boolean) => {
      const deeplinkingURLControl = this.addToolFormGroup.get('deeplinkingURL');
      if (checked) {
        deeplinkingURLControl?.enable();
        deeplinkingURLControl?.setValidators([Validators.required, Validators.pattern(this.URL_PATTERN)]);
      } else {
        deeplinkingURLControl?.clearValidators();
        deeplinkingURLControl?.reset();
        deeplinkingURLControl?.disable();
      }
      deeplinkingURLControl?.updateValueAndValidity();
    });
  }

  

  async onSubmit() {
     if (!this.addToolFormGroup.valid) {
         this.toastService.show({
           severity: 'error',
           summary: 'Error',
           detail: 'Please correct the errors in the form.'
         });
         this.addToolFormGroup.markAllAsTouched();
         return;
       }else{
          try{
            await this.toolsService.createTool(this.addToolFormGroup.value)
            this.toastService.show({
              severity: 'success',
              summary: 'Tool Created.',
              detail: 'Tool created successfully.'
            });
            this.addToolFormGroup.markAllAsTouched();
            this.router.navigate(['/view-tools'])
          }catch(e){
              this.toastService.show({
              severity: 'error',
              summary: 'Error',
              detail: 'There was a problem during create tool, please contact support.'
            });
          }
       }
    }    
}
